import { useEffect, useState } from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';
import { withBase } from '../../utils/route.util';

const SESSION_TIMEOUT_MIN = parseInt(process.env.REACT_APP_SESSION_TIMEOUT, 10); // minutes
const WARNING_DURATION_MIN = parseInt(
  process.env.REACT_APP_WARNING_TIMEOUT,
  10,
); // minutes

const SESSION_TIMEOUT_DURATION = SESSION_TIMEOUT_MIN * 60 * 1000; // ms
const WARNING_DURATION = WARNING_DURATION_MIN * 60 * 1000; // ms

function SessionTimeout() {
  const [showModal, setShowModal] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);

  const resetTimer = () => {
    localStorage.setItem('lastActivity', Date.now().toString());
  };

  const handleUserActivity = () => {
    resetTimer();
  };

  const logout = () => {
    setShowModal(false);
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace(withBase('/login'));
  };

  const stay = () => {
    resetTimer();
    setShowModal(false);
  };

  useEffect(() => {
    // Add event listeners for user activity
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach(event => {
      document.addEventListener(event, handleUserActivity);
    });

    // Check session status every second (more responsive for warnings)
    const interval = setInterval(() => {
      const companyCode =
        sessionStorage.getItem('companyCode') ||
        localStorage.getItem('companyCode');
      const accessToken =
        sessionStorage.getItem('accessToken') ||
        localStorage.getItem('accessToken');

      if (!companyCode) {
        return;
      }
      const lastActivity = parseInt(
        localStorage.getItem('lastActivity') || '0',
        10,
      );
      const now = Date.now();
      const timeSinceLastActivity = now - lastActivity;

      if (timeSinceLastActivity >= SESSION_TIMEOUT_DURATION) {
        setShowModal(false);
        logout();
        return;
      }

      // Show warning when within WARNING_DURATION of timeout
      const warningThreshold = SESSION_TIMEOUT_DURATION - WARNING_DURATION;
      if (timeSinceLastActivity >= warningThreshold) {
        const timeLeftMs = Math.max(
          0,
          SESSION_TIMEOUT_DURATION - timeSinceLastActivity,
        );
        const timeLeftMins = Math.ceil(timeLeftMs / (60 * 1000));
        if (timeLeftMins > 0 && accessToken) {
          setTimeLeft(timeLeftMins);
          setShowModal(true);
        } else {
          setShowModal(false);
          logout();
        }
      } else if (showModal) {
        // ensure modal hidden if not in warning zone
        setShowModal(false);
      }
    }, 60000); // run every second

    // Initialize last activity
    resetTimer();

    // Cleanup
    return () => {
      events.forEach(event => {
        document.removeEventListener(event, handleUserActivity);
      });
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal isOpen={showModal} centered>
      <ModalBody>
        <h4>Session Timeout Warning</h4>
        <p>Your session will expire in {timeLeft} minutes due to inactivity.</p>
        <div className="d-flex justify-content-center gap-2">
          <Button className="custom-secondary-btn" onClick={logout}>
            Logout
          </Button>
          <Button className="custom-btn" onClick={stay}>
            Stay Connected
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default SessionTimeout;
